import { level, linePlot, periodInput } from "../definitionHelpers";
import { PALETTE } from "../palette";
import { MA_TYPE } from "../indicatorTypes";
import { fillMovingAverage } from "../math/movingAverages";

const PERCENT = 100;
const EPSILON = 1e-10;

// Rise (gain) and fall (loss) of the close against the previous one; none on the first bar
const changeReader = (bars, sign) => (index) =>
  index < 1 ? NaN : Math.max(0, sign * (bars[index].close - bars[index - 1].close));

const isZero = (value) => Math.abs(value) <= EPSILON;

/**
 * RSI (research §1.4), as TV Relative Strength Index: RMA of the gains and
 * of the losses of the close over Period, 100 − 100 / (1 + gain / loss).
 */
export default {
  id: "rsi",
  name: "RSI",
  isOscillator: true,
  decimals: 2,
  inputs: [
    periodInput("period", "Period", 14),
  ],
  plots: [
    linePlot("value", "Main Line", PALETTE.LIME),
  ],
  buffers: ["gain", "loss"],
  levels: [level(70, PALETTE.AQUA), level(50, PALETTE.SILVER), level(30, PALETTE.YELLOW)],

  calculate: (bars, { period }, series, fromIndex) => {
    const range = { type: MA_TYPE.SMMA, period, fromIndex, toIndex: bars.length };

    fillMovingAverage({ ...range, read: changeReader(bars, 1), target: series.gain });
    fillMovingAverage({ ...range, read: changeReader(bars, -1), target: series.loss });

    for (let index = fromIndex; index < bars.length; index += 1) {
      const gain = series.gain[index];
      const loss = series.loss[index];
      let value = PERCENT - PERCENT / (1 + gain / loss);

      if (isZero(loss)) value = PERCENT;
      else if (isZero(gain)) value = 0;

      series.value[index] = value;
    }
  },
};
